import { createSuccessCodeWithZero } from './request'

const request = createSuccessCodeWithZero()

export function getQuotaList(surveyId) {
  return request.get(`/quota/surveyQuotaNew/list/${surveyId}`)
}

export function createQuota(quota) {
  return request.post('/quota/surveyQuotaNew', quota)
}

export function updateQuota(quota) {
  return request.put('/quota/surveyQuotaNew', quota)
}

export function removeQuota(id) {
  return request.delete(`/quota/surveyQuotaNew/${id}`)
}

export function refreshQuota(id) {
  return request.get(`/quota/surveyQuotaNew/refresh?quotaId=${id}`)
}

export function getQuotaById(id) {
  return request.get(`/quota/surveyQuotaNew/refresh?quotaId=${id}`)
}

export function getCurrentAnswerSurveyByQuotaId(params) {
  return request.get(`/quota/surveyQuotaNew/listAnswering`, {
    params
  })
}

export function batchFailAnswerByIds(ids) {
  return request.post('/answer/answer/multiInvalid', ids)
}
